import { createFileRoute } from "@tanstack/react-router";
import { loadLegacyContent, LegacyContent, legacyHead } from "@/lib/legacy-content";

export const Route = createFileRoute("/ophthalmologist")({
  loader: () => loadLegacyContent("ophthalmologist"),
  head: ({ loaderData }) =>
    loaderData ? legacyHead("/ophthalmologist", loaderData) : { meta: [{ title: "Ophthalmology — Healic" }] },
  component: () => <LegacyContent payload={Route.useLoaderData()} />,
});
